import {MACHINE_DOCUMENT_SCHEMA_TYPE} from "../../machines/actions/machineActions";
import {
  OUTSOURCE_DOCUMENT_SCHEMA_MONTHLY_TYPE,
  OUTSOURCE_DOCUMENT_SCHEMA_TYPE, WORK_DOCUMENT_SCHEMA_LINK_TYPE, WORK_DOCUMENT_SCHEMA_TYPE,
  WORKER_DOCUMENT_SCHEMA_TYPE
} from "../actions/schemaTypeActions";
import DocumentSchemaType from "../../shared/model/DocumentSchemaType";
import {I18nUtils} from "../../../i18n/I18nUtils";

const INITIAL_STATE = {
  workerDocumentSchemaType: [],
  machineDocumentSchemaType: [],
  workDocumentSchemaType: [],
  workDocumentSchemaLinkType: [],
  outsourceDocumentSchemaType: [],
  outsourceDocumentSchemaMonthlyType: [],
  schemaType: [
      {
          "id": DocumentSchemaType.WORKER,
          "name": I18nUtils.tr('TR_TRABAJADOR'),
      },
      {
          "id": DocumentSchemaType.MACHINE,
          "name": I18nUtils.tr('TR_MAQUINARIA'),
      },
      {
          "id": DocumentSchemaType.OUTSOURCE,
          "name": I18nUtils.tr('TR_SUBCONTRATA'),
      },
      {
          "id": DocumentSchemaType.WORK,
          "name": I18nUtils.tr('TR_OBRA'),
      },
      {
          "id": DocumentSchemaType.MONTHLY,
          "name": I18nUtils.tr('TR_MENSUAL'),
      },
      {
          "id": DocumentSchemaType.LINKED,
          "name": I18nUtils.tr('TR_VINCULADOS'),
      },
  ]
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WORKER_DOCUMENT_SCHEMA_TYPE:
      return {
        ...state,
        workerDocumentSchemaType: [...action.payload],
      };
    case MACHINE_DOCUMENT_SCHEMA_TYPE:
      return {
          ...state,
          machineDocumentSchemaType: [...action.payload],
      };
    case WORK_DOCUMENT_SCHEMA_TYPE:
      return {
        ...state,
        workDocumentSchemaType: [...action.payload],
      };
    case WORK_DOCUMENT_SCHEMA_LINK_TYPE:
      return {
        ...state,
        workDocumentSchemaLinkType: [...action.payload],
      };
    case OUTSOURCE_DOCUMENT_SCHEMA_TYPE:
      return {
        ...state,
        outsourceDocumentSchemaType: [...action.payload],
      };
    case OUTSOURCE_DOCUMENT_SCHEMA_MONTHLY_TYPE:
      return {
        ...state,
        outsourceDocumentSchemaMonthlyType: [...action.payload],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/documents/reducers/SchemaTypeReducer.js